import React from "react";
import AbbreviationsTable from "../tables/AbbreviationsTable";
import { useState, useEffect } from "react";
import { UseSorting } from "../common/UseSorting";
function AbbreviationsTab({
  data = [],
  searchTerm = "",
  currentPage = 1,
  itemsPerPage = 5,
  handleEditClick,
  handleDeleteClick,
  selectedRows,
  setSelectedRows,
}) {
  const { sortConfig, handleSort, renderSortIcon, sortData, resetSort } =
    UseSorting();
  const sortableFields = ["ABBREVIATION", "REPLACE_WORD"];

    // Reset sort when tab data changes
  useEffect(() => {
    resetSort();
  }, [data]);
  
  const sortedData = sortData(Array.isArray(data) ? data : [], sortableFields);
  // ✅ All IDs from ALL pages
  const allIds = sortedData.map((r) => r.record_id);
    // ✅ Is *every* record selected?
  const isAllSelected =
    allIds.length > 0 && allIds.every((id) => selectedRows.includes(id));

  // ✅ Is there at least one selected, but not all?
  const isSomeSelected =
    selectedRows.length > 0 &&
    !isAllSelected &&
    selectedRows.some((id) => allIds.includes(id));


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  // ✅ Select/Deselect ALL rows from ALL pages
  const handleSelectAll = (isChecked) => {
    if (!Array.isArray(sortedData) || sortedData.length === 0) {
      return;
    }

    const allIds = sortedData.map((r) => r.record_id);

    setSelectedRows((prev) => {
      return isChecked
        ? Array.from(new Set([...prev, ...allIds])) // select all rows in all pages
        : prev.filter((id) => !allIds.includes(id)); // deselect all rows in all pages
    });
  };

  return (
    <AbbreviationsTable
      data={currentItems}
      startIndex={indexOfFirstItem}
      handleEditClick={handleEditClick}
      handleDeleteClick={handleDeleteClick}
      searchTerm={searchTerm}
      selectedRows={selectedRows}
      handleSelectRow={(id) => {
        setSelectedRows((prev) =>
          prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id]
        );
      }}
      // ✅ Now we only pass `isChecked` (no page data)
      handleSelectAll={handleSelectAll}
      sortableFields={sortableFields}
      handleSort={handleSort}
      renderSortIcon={renderSortIcon}
            // 👇 pass global selection state
      isAllSelected={isAllSelected}
      isSomeSelected={isSomeSelected}
    />
  );
}

export default AbbreviationsTab;
